<template>
    <div class="page-root">
    <div id="particles-js"></div>
    <div class="container">
        <h1>RosterPal - Team - 2026</h1><br><br>
        <form @submit.prevent="handleSubmit" class="form">
            <v-row>
                <v-col cols="12" md="4">
                    <label for="date">Select Date:</label>
                    <input type="date" v-model="date" required />
                </v-col>

                <v-col cols="12" md="4">
                    <label for="team">Select Team: ( * for all teams)</label>
                    <select v-model="team">
                        <option v-for="option in dropdownOptions" :key="option">
                            {{ option }}
                        </option>
                    </select>

                </v-col>

                <v-col cols="12" md="4">
                    <label for="shift">Select Shift:</label>
                    <select v-model="shift" required>
                        <option value="now">NOW</option>
                        <option value="m">Morning (7-4)</option>
                        <option value="d">Regular (8-5)</option>
                        <option value="e">EU (12.30-9.30)</option>
                        <option value="a">Afternoon (3-12)</option>
                        <option value="n">Night (11-8)</option>
                    </select>
                </v-col>

                <button type="submit" class="submit-button">Show the team</button>
            </v-row>
        </form>
        <center v-if="loader">
            <div class="loader"></div>
        </center>
        <div v-if="result && result.length" class="result">
            <h2>Response Data:</h2>
            <v-chip-group class="d-flex flex-column">
                <v-chip v-for="(value, key) in aboutData" :key="key"
                    :style="{ backgroundColor: getChipColor(key), color: 'white' }">
                    {{ value }}
                </v-chip>
            </v-chip-group>
            <table>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Shift</th>
                        <th>Role</th>
                        <th>Area</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in result" :key="index"
                        :style="{ backgroundColor: item.role.startsWith('Shift') || item.role.includes('TL') || item.role.includes('Manager') ? '#ebdbff' : 'white' }">
                        <td>{{ item.name }}</td>
                        <td>{{ item.shift }}</td>
                        <td>{{ item.role }}</td>
                        <td>{{ item.cap }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <modal-component :isVisible="showModal" :options="options" @close="showModal = false"
            @select="handleSelect"></modal-component>
        <v-snackbar v-model="snackbar" centered>
            Invalid Data

            <template v-slot:actions>
                <v-btn color="pink" variant="text" @click="snackbar = false">
                    Close
                </v-btn>
            </template>
        </v-snackbar>
        <v-snackbar v-model="snackbar_noData" centered>
            No Data Found

            <template v-slot:actions>
                <v-btn color="red" variant="text" @click="snackbar_noData = false">
                    Close
                </v-btn>
            </template>
        </v-snackbar>

    </div>
    </div>
</template>

<script>
import ModalComponent from './ModalComponent.vue';
export default {
    components: {
        ModalComponent
    },
    data() {
        return {
            date: new Date().toISOString().split("T")[0],

            team: "Industry - energy",
            dropdownOptions: [],

            loader: false,

            shift: "now",
            result: null,
            showModal: false,
            aboutData: null,
            options: [],
            snackbar: false,
            snackbar_noData: false,
            url: "",
            shiftString: ''
        };
    },

    methods: {
         initParticles() {
        if (!window.particlesJS) return;

        particlesJS("particles-js", {
            particles: {
                number: {
                    value: 150,
                    density: { enable: true, value_area: 800 }
                },
                color: {
                    value: ["#aa87d7", "#8a5db8", "#6a3399"]
                },
                shape: { type: "circle" },
                opacity: { value: 4 },
                size: { value: 4, random: true },
                move: {
                    enable: true,
                    speed: 2,
                    direction: "none",
                    out_mode: "out"
                }
            },
            interactivity: {
                events: {
                    onhover: { enable: false },
                    onclick: { enable: false }
                }
            },
            retina_detect: true
        });
    },
        async handleSubmit() {
            this.loader = true
            this.shiftString = ''
            this.snackbar_noData = false;
            this.snackbar = false;
            this.result = null;
            const formattedDate = this.date.replace(/-/g, "/");
            const year = formattedDate.split('/')[0];
            if (year != 2026) {
                alert("RosterPal only has data of the year 2026");
                this.loader = false
                return
            }
            if (this.shift == 'now') {

                let now = new Date();
                let hours = now.getHours();
                // let hours = 15.31;
                let minutes = now.getMinutes();

                this.shiftString = ''; // Reset shiftString

                if (hours >= 7 && hours < 16) {
                    this.shiftString += 'm'; // Morning shift
                }
                if ((hours > 12 || (hours === 12 && minutes >= 30)) && (hours < 21 || (hours === 21 && minutes < 30))) {
                    this.shiftString += 'e'; // EU shift
                }
                if (hours >= 8 && hours < 17) {
                    this.shiftString += 'd'; // Day shift
                    this.shiftString += 'r'; // Regular shift
                }
                if (hours >= 15 && hours < 24) {
                    this.shiftString += 'a'; // Afternoon shift
                }

                // Night shift handling:
                if (hours === 23) {
                    this.shiftString += 'n'; // Current day night shift
                } else if (hours < 8) {
                    this.shiftString += 'b'; // Previous day night shift
                }


                this.url = `https://rosterpalb.induwara.me/listCurrentMembers/${formattedDate}/${this.team}/${this.shiftString}`;
                // this.url = `http://127.0.0.1:5000/listCurrentMembers/${formattedDate}/${this.team}/${this.shiftString}`;
            } else {
                this.url = `https://rosterpalb.induwara.me/listMembers/${formattedDate}/${this.team}/${this.shift}`;
                // this.url = `http://127.0.0.1:5000/listMembers/${formattedDate}/${this.team}/${this.shift}`;
            }

            try {
                const response = await fetch(this.url);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();

                if (data[0].Verticle) {
                    // console.log(data);
                    this.aboutData = data.slice(0).flat()[0]; // Assuming this returns the about object
                    // this.result = data.slice(1).flat();
                    var temp = data.slice(1).flat();
                    // console.log(temp);
                    this.result = temp

                    if (this.result.length < 1) {
                        this.snackbar_noData = true;
                    }

                    localStorage.setItem("teamCookie", this.team);
                    this.loader = false
                } else {
                    this.options = this.extractOptions(data); // Extract options based on your logic
                    this.showModal = true; // Show the modal
                    // Handle the case where the response does not match the expected format
                    console.log("Unexpected response format:", response);
                    this.loader = false
                }
            } catch (error) {
                this.snackbar = true
                console.error('Error fetching data:', error);
                this.loader = false
            }
        },
        async fetchDropdownOptions() {
            // Check if data exists in localStorage
            const newTeamVersion = 5;
            const currentTeamVersion = localStorage.getItem("currentTeamVersion");
            if (currentTeamVersion) {
                if (newTeamVersion != currentTeamVersion) {
                    localStorage.setItem("currentTeamVersion", newTeamVersion); // Save in local storage
                    localStorage.removeItem("dropdownOptions");
                }
            } else {
                localStorage.setItem("currentTeamVersion", newTeamVersion); // Save in local storage
                localStorage.removeItem("dropdownOptions");
            }
            const storedOptions = localStorage.getItem("dropdownOptions");
            if (storedOptions) {
                this.dropdownOptions = JSON.parse(storedOptions);
            } else {
                this.loader = true

                try {
                    // Fetch from API if not found in localStorage
                    //const response = await fetch("http://127.0.0.1:5000/getAllTeams");
                    const response = await fetch("https://rosterpalb.induwara.me/getAllTeams");

                    if (!response.ok) {
                        console.log('Error while fetching teams:', response.statusText);
                        throw new Error("Failed to fetch");
                    }

                    const data = await response.json();

                    if (!data.teams || !Array.isArray(data.teams)) {
                        throw new Error("Invalid data format from API");
                    }

                    this.dropdownOptions = data.teams;
                    localStorage.setItem("dropdownOptions", JSON.stringify(data.teams)); // Save in local storage

                    // console.log("Dropdown options successfully loaded:", this.dropdownOptions);
                    this.loader = false

                } catch (error) {
                    alert('Try again after clearing browser cache')
                    console.error("Error fetching dropdown options:", error.message);
                    this.loader = false

                }


            }
        },
        shiftLabel(shift) {
            switch (shift) {
                case 'm':
                    return 'Morning';
                case 'd':
                    return 'Day';
                case 'e':
                    return 'Evening';
                case 'a':
                    return 'Afternoon';
                case 'n':
                    return 'Night';
                default:
                    return 'Unknown';
            }
        }, extractOptions(data) {
            // Logic to extract options from the response data
            return data.map(item => item); // Replace 'someProperty' with the relevant property
        },
        handleSelect(option) {
            this.team = option
            this.handleSubmit()
            // console.log("Selected option:", option);
            // Handle the selected option here
        },
        getChipColor(key) {
            switch (key) {
                case 'Verticle':
                    return '#ffab00'; // Vivid Amber
                case 'Team':
                    return '#6a3399'; // Deep Purple (Anchor)
                default:
                    return '#00b8d4'; // Vivid Cyan
            }
        }
    },
    mounted() {
        const savedName = localStorage.getItem("teamCookie");
        if (savedName) {
            this.team = savedName;
        }
        this.fetchDropdownOptions();
        this.initParticles();
    }
};
</script>


<style scoped>
/* HTML: <div class="loader"></div> */
.loader {
    --s: 25px;
    --g: 65px;

    width: calc(3*(1.353*var(--s) + var(--g)));
    display: grid;
    justify-items: end;
    aspect-ratio: 3;
    overflow: hidden;
    --_m: linear-gradient(90deg, #0000, #000 15px calc(100% - 15px), #0000);
    -webkit-mask: var(--_m);
    mask: var(--_m);
}

.loader:before {
    content: "";
    width: 200%;
    background:
        linear-gradient(90deg, #6a3399 50%, #0000 0),
        conic-gradient(from -90deg at var(--s) calc(0.353*var(--s)),
            #fff 135deg, #cab1f6 0 270deg, #aa87d7 0);
    background-blend-mode: multiply;
    --_m:
        linear-gradient(to bottom right,
            #0000 calc(0.25*var(--s)), #000 0 calc(100% - calc(0.25*var(--s)) - 1.414*var(--g)), #0000 0),
        conic-gradient(from -90deg at right var(--g) bottom var(--g), #000 90deg, #0000 0);
    -webkit-mask: var(--_m);
    mask: var(--_m);
    background-size: calc(100%/3) 100%, calc(100%/6) 100%;
    -webkit-mask-size: calc(100%/6) 100%;
    mask-size: calc(100%/6) 100%;
    -webkit-mask-composite: source-in;
    mask-composite: intersect;
    animation: l10 1s infinite linear;
}

@keyframes l10 {
    to {
        transform: translate(calc(100%/3))
    }
}



body {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    font-family: Arial, sans-serif;
    margin: 0;
    padding: 0;
    background-color: #f8f4ff;
    color: #333;
}

.container {
    flex: 1;
    width: 90%;
    max-width: 1200px;
    margin: 2rem auto;
    padding: 1.5rem;
    background-color: #fff;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
}

h1 {
    text-align: center;
    color: #6a3399;
}

form {
    margin-bottom: 2rem;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 1rem;
}

label {
    margin-right: 0.5rem;
    font-weight: bold;
}

input[type="date"],
input[type="text"],
select,
button {
    padding: 0.75rem;
    font-size: 1rem;
    border: 1px solid #ddd;
    border-radius: 4px;
    width: 100%;
    box-sizing: border-box;
}

.button {
    padding: 0.75rem;
    font-size: 1rem;
    border: 1px solid #ddd;
    border-radius: 50px; /* Makes the edges nicely rounded */
    width: 50%;
    box-sizing: border-box;
    background-color: #7d7d7d;
    color: white; /* Optional: improves contrast */
}


button {
    background-color: #6a3399;
    color: white;
    border: none;
    cursor: pointer;
}

button:hover {
    background-color: #4a236c;
}

.result {
    margin-top: 1.5rem;
    padding: 1.5rem;
    border: 1px solid #ddd;
    background-color: #fafafa;
    border-radius: 8px;
}


.result h2 {
    margin-top: 0;
    color: #6a3399;
}

.result table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 1rem;
}

.result table,
.result th,
.result td {
    border: 1px solid #ddd;
    padding: 0.75rem;
    text-align: left;
}

.result th {
    background-color: #6a3399;
    color: white;
}

.response-text {
    background-color: #f4f4f4;
    padding: 1rem;
    border-radius: 4px;
    white-space: pre-wrap;
    word-wrap: break-word;
}

footer {
    text-align: center;
    padding: 1rem;
    background-color: #333;
    color: white;
}

@media (min-width: 600px) {
    .container {
        width: 80%;
    }

    form {
        justify-content: space-between;
    }
}


.page-root {
    position: relative;
    min-height: 100vh;
}

#particles-js {
    position: fixed;
    inset: 0;
    z-index: -1;
    background-color: #eee;
}

</style>